import {
    InputContext,
    inputContextToColor,
} from 'dg-web-shared/tb-ui/inputs/InputContext';

import { css } from '@emotion/css';
import { JsxMessage, Message } from 'dg-web-shared/lib/Localized.ts';
import { Label } from 'dg-web-shared/tb-ui/inputs/internal/Label.tsx';
import React from 'react';
import { Typo } from 'dg-web-shared/ui/typo.ts';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';

interface Props {
    label: string | JsxMessage | Message;
    context?: InputContext;
    selectable?: boolean;
    rightText?: string;
    children?: React.ReactNode;
    key?: React.Key;
    rightAlign?: boolean;
    compactHeight?: number;
    superCompactHeight?: number;
}

export function LabeledText({
    label,
    context,
    selectable,
    rightText,
    children,
    rightAlign,
    compactHeight,
    superCompactHeight,
}: Props) {
    const color = inputContextToColor(context || InputContext.regular);

    return (
        <div
            className={css({
                color: color,
                ...Typo.captionC4,
                marginTop: '8px',
                marginBottom: '24px',
                [`@media(max-height: ${compactHeight || 0}px)`]: {
                    marginTop: 0,
                    marginBottom: '12px',
                },
                [`@media(max-height: ${superCompactHeight || 0}px)`]: {
                    marginBottom: '8px',
                    marginTop: 0,
                },
                textAlign: rightAlign ? 'right' : 'left',
            })}
        >
            <Label
                context={context || InputContext.regular}
                elevated={true}
                hideHeight={superCompactHeight}
                rightText={rightText}
                text={
                    typeof label === 'string' ? label : <Localized {...label} />
                }
            />
            <div
                className={css({
                    ...Typo.body,
                    color: color,
                    userSelect: selectable ? 'text' : 'auto',
                })}
            >
                {children}
            </div>
        </div>
    );
}

export const Factory = (
    props: Props,
    ...children: React.ReactNode[]
): React.ReactElement => React.createElement(LabeledText, props, ...children);
